import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { removeBoard } from '../shared/boardCleanup.actions'
import {
  createEmptyBoardFilterStickersBoardState,
  createInitialBoardFilterStickersState,
} from './boardFilterStickers.state.utils'
import { fetchBoardFilterStickersThunk } from './boardFilterStickers.thunks'

const ensureBoard = (
  state: ReturnType<typeof createInitialBoardFilterStickersState>,
  boardId: number,
) => {
  if (!state.byBoardId[boardId]) {
    state.byBoardId[boardId] = createEmptyBoardFilterStickersBoardState()
  }
  return state.byBoardId[boardId]
}

const boardFilterStickersSlice = createSlice({
  name: 'taskTrackerBoardFilterStickers',
  initialState: createInitialBoardFilterStickersState(),
  reducers: {
    bumpBoardFilterStickersReloadToken(state, action: PayloadAction<number>) {
      const boardId = action.payload
      state.reloadTokens[boardId] = (state.reloadTokens[boardId] ?? 0) + 1
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(removeBoard, (state, action) => {
        const boardId = action.payload.boardId
        delete state.reloadTokens[boardId]
        delete state.byBoardId[boardId]
      })
      .addCase(fetchBoardFilterStickersThunk.pending, (state, action) => {
        if (action.meta.arg.silent) return
        const stickersState = ensureBoard(state, action.meta.arg.boardId)
        stickersState.loading = true
        stickersState.error = null
      })
      .addCase(fetchBoardFilterStickersThunk.fulfilled, (state, action) => {
        const stickersState = ensureBoard(state, action.payload.boardId)
        stickersState.rows = action.payload.rows
        stickersState.visibleStickerRows = action.payload.visibleStickerRows
        stickersState.allStickerRows = action.payload.allStickerRows
        stickersState.error = null
        stickersState.isInitialized = true
        if (!action.payload.silent) {
          stickersState.loading = false
        }
      })
      .addCase(fetchBoardFilterStickersThunk.rejected, (state, action) => {
        const payload = action.payload as {
          boardId: number
          silent: boolean
          error: string
        }
        if (payload.silent) return
        const stickersState = ensureBoard(state, payload.boardId)
        stickersState.rows = []
        stickersState.visibleStickerRows = []
        stickersState.allStickerRows = []
        stickersState.error = payload.error
        stickersState.loading = false
        stickersState.isInitialized = true
      })
  },
})

export const { bumpBoardFilterStickersReloadToken } = boardFilterStickersSlice.actions

export default boardFilterStickersSlice.reducer
